import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'fm-public',
    templateUrl: './public.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PublicComponent {
  constructor() {

  }


}
